import { gql } from '@apollo/client'

const INFLUENCER_HUB_FIELDS = gql`
  fragment BaseInfluencerHubFields on InfluencerHubType {
    id
    coverImage
    description
    influencerPlatform
    influencerType
    name
    order
    socialLink
  }
`

export const FIND_ALL_INFLUENCER_HUB = gql`
  ${INFLUENCER_HUB_FIELDS}
  query FindAllInfluencerHub($query: InfluencerHubQueryInput!) {
    findAllInfluencerHub(query: $query) {
      count
      items {
        ...BaseInfluencerHubFields
      }
    }
  }
`

export const CREATE_INFLUENCER_HUB = gql`
  ${INFLUENCER_HUB_FIELDS}
  mutation CreateInfluencerHub($createInfluencerHubInput: CreateInfluencerHubInput!) {
    createInfluencerHub(createInfluencerHubInput: $createInfluencerHubInput) {
      ...BaseInfluencerHubFields
    }
  }
`

export const UPDATE_INFLUENCER_HUB = gql`
  ${INFLUENCER_HUB_FIELDS}
  mutation UpdateInfluencerHub($updateInfluencerHubInputFieldName: UpdateInfluencerHubInput!) {
    updateInfluencerHub(updateInfluencerHubInputFieldName: $updateInfluencerHubInputFieldName) {
      ...BaseInfluencerHubFields
    }
  }
`

export const REMOVE_INFLUENCER_HUB = gql`
  mutation RemoveInfluencerHub($id: String!) {
    removeInfluencerHub(id: $id) {
      affected
    }
  }
`

export const BULK_UPDATE_INFLUENCER_HUB = gql`
  mutation BulkUpdateInfluencerHub($bulkUpdateInfluencerHubInput: [BulkUpdateInfluencerHubInput!]!) {
    bulkUpdateInfluencerHub(bulkUpdateInfluencerHubInput: $bulkUpdateInfluencerHubInput) {
      id
    }
  }
`
